// Background images are user-uploaded photos used as post backgrounds
// Separate from brand assets which are logos/design elements for templates

export interface BackgroundImage {
  id: string;
  workspaceId: string;
  name: string;
  url: string;
  type: string;
  createdAt: string;
}

export interface CreateBackgroundImageRequest {
  name: string;
  url: string;
  type?: string;
}
